var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.nameSettings.hasActiveFields()
    ? _c(
        "w-row",
        [
          _c(
            "w-col",
            { staticClass: "input-container", attrs: { xs: "12", md: "12" } },
            [
              _vm._l(_vm.numKeys, function (key) {
                return [
                  _vm.isActive(key)
                    ? _c("app-label", {
                        key: key,
                        attrs: {
                          value: _vm.value[key],
                          label: _vm.getLabel(key),
                          decimals: _vm.getDecimalsOfKey(key),
                        },
                      })
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
          _c(
            "w-col",
            { staticClass: "input-container", attrs: { xs: "12", md: "12" } },
            [
              _vm._l(_vm.textKeys, function (key) {
                return [
                  _vm.isActive(key)
                    ? _c("app-label", {
                        key: key,
                        attrs: {
                          value: _vm.getTextValue(_vm.value[key], key),
                          label: _vm.getLabel(key),
                          textarea: "",
                        },
                      })
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
          _vm._l(_vm.formattedTextKeys, function (key) {
            return [
              _vm.isActive(key)
                ? _c(
                    "w-col",
                    {
                      key: key,
                      staticClass: "input-container",
                      attrs: { xs: "12", md: "12" },
                    },
                    [
                      _c("div", { staticClass: "formatted-label" }, [
                        _vm._v(_vm._s(_vm.getLabel(key))),
                      ]),
                      _c("div", {
                        staticClass: "formatted-content",
                        domProps: { innerHTML: _vm._s(_vm.value[key] || "") },
                      }),
                    ]
                  )
                : _vm._e(),
            ]
          }),
          _c(
            "w-col",
            {
              staticClass: "input-container bools",
              attrs: { xs: "12", md: "12" },
            },
            [
              _vm._l(_vm.boolKeys, function (key) {
                return [
                  _vm.isActive(key)
                    ? _c("app-label", {
                        key: key,
                        attrs: {
                          value: _vm.value[key],
                          label: _vm.getLabel(key),
                        },
                      })
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
          _c(
            "w-col",
            { staticClass: "input-container", attrs: { xs: "12", md: "12" } },
            [
              _vm._l(_vm.timeKeys, function (key) {
                return [
                  _vm.isActive(key)
                    ? _c("app-label", {
                        key: key,
                        attrs: {
                          value: _vm.printDate(_vm.value[key]),
                          label: _vm.getLabel(key),
                        },
                      })
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ],
        2
      )
    : _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", center: "" } },
            [
              _c("h4", [
                _vm._v(" " + _vm._s(_vm.$ct("no-active-fields")) + " "),
              ]),
              _c("w-link", { attrs: { to: "/settings/extra-field-names" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("setup-extra-fields")) + " "),
              ]),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }